import { DeviceOption } from 'src/app/pages/phones/models/device-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const deviceOptionActions = createEagerSelectActions<DeviceOption>('[Device Options]');
